import request from './request.js';
import {requestbody} from './request.js'
//页面初始化
export async function hjbhs_init(params = {

}) {
    return await requestbody('env/init', 'post', params)
}
//数据来源配置分页查询
export async function hjbhs_query(params = {

}) {
    return await requestbody('env/query', 'post', params)
}
//明细大气登记查询
export async function mxdj_query(params = {

}) {
    return await requestbody('env/details/query', 'post', params)
}
// 抽样查询
export async function cycs_query(params = {

}) {
    return await requestbody('env/details/cycs/query', 'post', params)
}
//明细登记查询
export async function mxdj_shuiyquery(params = {

}) {
    return await requestbody('env/shuiy/query', 'post', params)
}
//修改明细
export async function mxdj_update(params = {

}) {
    return await requestbody('env/update', 'post', params)
}
//清空数据
export async function hjbhs_clearNowTax_api(params = {

}) {
    return await requestbody('env/date/clear', 'post', params)
}

//税源修改
export async function mxdj_shuiyupdate(params = {

}) {
    return await requestbody('env/shuiy/update', 'post', params)
}
//清空数据
export async function hjbhs_import(params = {

}) {
    return await request('env/detail/import', 'post', params)
}